import Component from 'vue-class-component'
import Router from 'vue-router'
import Vue from 'vue'
import config from './config'
// Register the router hooks with their names
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave'
])
Vue.use(Router)
export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: config.app_name,
  routes: [
    {
      path: '/channelDetail',
      component: () => import("./pages/channelDetail.vue"),
      name: '专栏详情'
    },
    // {
    //   path: '/groupList',
    //   component: () => import("./pages/group/groupList.vue"),
    //   name: '团购列表'
    // },
    {
      name: '播放',
      path: '/lessonPlayPage',
      component: () => import('./pages/lessonPlayPage.vue')
    },
    // {
    //   name: '课程列表',
    //   path: '/partCourseList',
    //   component: () => import('./pages/channel/partCourseList.vue')
    // },
    {
      name: '领取优惠券',
      path: '/getInternalCouponList',
      component: () => import('./pages/comps/getInternalCouponList.vue'),
    },
    {
      name: '全部',
      path: '/',
      component: () => import('./pages/channel/channelListAll.vue')
    },
    // {
    //   name: '常青藤爸爸',
    //   path: '/homework',
    //   component: () => import('./pages/homework/index.vue')
    // },
    // {
    //   name: '常青藤爸爸',
    //   path: '/homework/landingPage',
    //   component: () => import('./pages/homework/landingPage.vue')
    // },
    // {
    //   name: '常青藤爸爸',
    //   path: '/homework/video',
    //   component: () => import('./pages/homework/video.vue')
    // },
    // {
    //   name: '常青藤爸爸',
    //   path: '/lockedCourseTip',
    //   component: () => import('./pages/comps/lockedCourseTip.vue')
    // },
    // {
    //   name: '测试页面',
    //   path: '/testPage',
    //   component: () => import('./pages/testPage.vue')
    // }
  ],
})
